module.exports = __webpack_public_path__ + "img/304.5d314a4c.png";